import "./Loader.css";

export default function Loader() {
  return (
    <div className="loader-screen">
      <div className="loader-content">
        <img
          src="/loadlogo.png"
          alt="Neha Shuttering"
          className="loader-logo"
        />

        <p className="loader-text">
          Building Strong Foundations...
        </p>
      </div>
    </div>
  );
}